import type { SimpleGit } from 'simple-git';

export async function revParseSafe(g: SimpleGit, ref: string): Promise<string | null> {
  try {
    const v = (await g.raw(['rev-parse', '--verify', ref])).trim();
    return v || null;
  } catch {
    return null;
  }
}
